module.exports = __webpack_public_path__ + "img/map-large-1.d3c844b7.jpg";